/** Presentation helpers only. Catalogue data always comes from the protected API. */
export const CATALOG_API = "/kpi/catalog/";
export const SECTIONS = [
    { id: "records", label: "Tutte le voci", count: "records" },
    { id: "groups", label: "Raggruppamenti", count: "groups" },
    { id: "proposals", label: "Definizioni proposte", count: "proposals" },
    { id: "findings", label: "Rilievi", count: "findings" },
    { id: "coverage", label: "Copertura e TV" },
];
export const REQUEST_OPTIONS = {
    ignoreGlobalErrorStatuses: [400, 401, 403, 404, 409, 503],
    ignoreSentryStatuses: [400, 401, 403, 404, 409, 503],
};
export function canAccessCatalog(user, loggedIn = true) {
    return loggedIn === true && user?.admin === true && user?.is_active !== false;
}
export function safeCatalogUrl(value) {
    if (typeof value !== "string" || Array.from(value).some(character => character.charCodeAt(0) <= 32)) return "";
    try {
        const url = new URL(value);
        return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password ? url.href : "";
    } catch (_) { return ""; }
}
export function catalogError(error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) return "Accesso negato. Il catalogo integrale è riservato agli amministratori autorizzati.";
    if (status === 409) return "Il catalogo è stato aggiornato. Ricarica la fotografia per consultare dati coerenti.";
    if (status === 404) return "Questa voce non è presente nella fotografia del catalogo.";
    if (status === 503) return "Il catalogo non è disponibile. Riprova più tardi: non equivale a un elenco vuoto.";
    if (status === 400) return "I filtri non sono validi. Azzera la ricerca e riprova.";
    return "Impossibile caricare il catalogo. Controlla la connessione e riprova.";
}
export function assertCatalogVersion(data, metadata) {
    if (data?.dataset_version !== metadata?.dataset_version || data?.dataset_sha256 !== metadata?.dataset_sha256) {
        const error = new Error("Catalogue version mismatch");
        error.response = { status: 409 };
        throw error;
    }
    return data;
}
export function listParameters(section, filters, page, version) {
    const params = { page, page_size: 25, version };
    if ((filters.q || "").trim()) params.q = (filters.q || "").trim().slice(0, 200);
    if (section === "records") {
        for (const name of ["system", "group", "related_group", "status", "proposal"]) if (filters[name]) params[name] = filters[name];
        if (filters.mapped !== "") params.mapped = filters.mapped === "true";
    }
    if (section === "proposals" && filters.group) params.group = filters.group;
    if (section === "findings" && filters.state) params.state = filters.state;
    return params;
}
export function blankFilters() { return { q: "", system: "", group: "", related_group: "", status: "", proposal: "", mapped: "", state: "" }; }
export function ids(item, key, legacy) { return item?.[key] || item?.[legacy] || []; }
export function evidencePresentation(item) {
    return {
        sql_mbql: { label: "Contenuto SQL / MBQL acquisito", description: "Contenuto SQL / MBQL acquisito; impostazioni della card, significato e risultati restano da verificare." },
        documentary: { label: "Evidenza documentale", description: "Sono disponibili note o estratti. La definizione nativa SQL / MBQL resta da recuperare." },
        code_reconstruction: { label: "Ricostruzione da codice", description: "Il calcolo è ricostruito dalle sorgenti del progetto; non è una definizione nativa Metabase." },
        none: { label: "Contenuto da recuperare", description: "Non è disponibile una definizione: il solo nome non permette di giudicare il calcolo." },
    }[item?.evidence_kind] || { label: "Evidenza da classificare", description: "La natura del contenuto non è classificata in questa fotografia: la sua presenza non prova una definizione nativa completa." };
}
export function nativeEvidenceMetrics(metadata) {
    const count = key => metadata.counts?.[key] ?? metadata.coverage?.[key];
    return [
        { label: "Metabase: contenuti SQL / MBQL acquisiti", value: count("metabase_sql_mbql_count") },
        { label: "Metabase: sole evidenze documentali", value: count("metabase_documentary_count") },
        { label: "Metabase: contenuto non acquisito", value: count("metabase_no_content_count") },
        { label: "Metabase: definizioni native da recuperare (documentali + senza contenuto)", value: count("metabase_without_native_content_count") },
    ];
}
export function csvCell(value) {
    let text = Array.isArray(value) ? value.map(item => typeof item === "object" ? JSON.stringify(item) : item).join(" | ") : String(value ?? "");
    if (/^[\s]*[=+@-]|^[\t\r\n]/.test(text)) text = "'" + text;
    return '"' + text.replaceAll('"', '""') + '"';
}
export function pageCsv(rows) {
    const fields = ["id", "name", "system", "domain", "status", "group_id", "group_basis", "formula", "rules", "state", "scope", "action", "proposal_ids", "finding_ids"];
    return "\ufeff" + [fields.join(";"), ...rows.map(row => fields.map(field => csvCell(row[field])).join(";"))].join("\r\n");
}
